import { App } from 'vue';

const fillZero = (num: number): string => (num < 10 ? `0${num}` : `${num}`);

export interface IGlobalFilter {
  overCount(value: number | string | undefined): string | number;
  shortDisplayTime(timestamp: number, currentTime?: number): string;
  displayTime(timestamp: number): string
}

const filters: IGlobalFilter = {
  overCount(value: number | string | undefined): string | number {
    if (!value) return 0;
    const count = typeof value === 'string' ? parseInt(value, 10) : value;
    if (count > 999) {
      return '999+';
    }
    return count;
  },
  shortDisplayTime(timestamp: number, currentTime = 0): string {
    if (!timestamp || timestamp < 100000) return '';
    const time = new Date(timestamp);
    const now = currentTime ? new Date(currentTime) : new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const yesterday = new Date(today.getTime() - 24 * 60 * 60 * 1000);

    if (time.getFullYear() !== now.getFullYear()) {
      // 不同年 'y-M-d'
      return `${time.getFullYear()}-${time.getMonth() + 1}-${time.getDate()}`;
    } if (time.getTime() < yesterday.getTime()) {
      // 同年的前天及以前 'M-d'
      return `${time.getMonth() + 1}-${time.getDate()}`;
    } if (time.getTime() > yesterday.getTime() && time.getTime() < today.getTime()) {
      return '昨天';
    } if (time.getMonth() === now.getMonth() && time.getDate() === now.getDate()) {
      //  h:m
      const hours = time.getHours();
      return `${fillZero(hours)}:${fillZero(time.getMinutes())}`;
    }
    return `${time.getFullYear()}-${time.getMonth() + 1}-${time.getDate()}`;
  },
  displayTime(timestamp: number): string {
    if (!timestamp || timestamp < 100000) return '';
    const targetDate = new Date(timestamp);
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const todayTimestamp = today.getTime();
    const yesterday = new Date(today.getTime() - 24 * 60 * 60 * 1000);
    const yesterdayTimestamp = yesterday.getTime();
    const DAY_MILL_SECOND = 24 * 60 * 60 * 1000;
    // 先判断是否是今天
    if (timestamp > todayTimestamp && timestamp < (todayTimestamp + DAY_MILL_SECOND)) {
      return `${fillZero(targetDate.getHours())}:${fillZero(targetDate.getMinutes())}`;
    }
    // 判断是否是昨天
    if (timestamp > yesterdayTimestamp && timestamp < (yesterdayTimestamp + DAY_MILL_SECOND)) {
      return `昨天 ${fillZero(targetDate.getHours())}:${fillZero(targetDate.getMinutes())}`;
    }
    // 判断是否是今年
    const currentYear = new Date(now.getFullYear());
    const currentYearTimestamp = currentYear.getTime();
    const nextYearTimestamp = new Date(now.getFullYear() + 1).getTime();
    if (timestamp > currentYearTimestamp && timestamp < (currentYearTimestamp + nextYearTimestamp)) {
      return `${fillZero(targetDate.getMonth() + 1)}-${fillZero(targetDate.getDate())} ${fillZero(targetDate.getHours())}:${fillZero(targetDate.getMinutes())}`;
    }
    return `${targetDate.getFullYear()}-${fillZero(targetDate.getMonth() + 1)}-${fillZero(targetDate.getDate())} ${fillZero(targetDate.getHours())}:${fillZero(targetDate.getMinutes())}`;
  },
};

export default function (app: App) {
  // eslint-disable-next-line no-param-reassign
  app.config.globalProperties.$filters = filters;
}
